
    export default {
        props: ['error'],
    }
